import { useContext } from "react";
import { useCallback } from "react";
import Select from "react-select";
import MainGroupsActions from "../../../../Actions/GroupsActions/MainGroupsActions";
import { MainGroupsContext } from "../../../../Contexts/GroupsContext/MainGroupsContext";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "250px",
    fontSize: "15px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function Selector({ param, property, value }) {
  const { dispatchMainGroups } = useContext(MainGroupsContext);

  const handleSelectChange = useCallback(async (e) => {
    if (property === "Fanlar") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: { page: 1, subject: e?.value == undefined ? "" : e?.value },
      });
    }
    if (property === "Guruh statusi") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: {
          page: 1,
          status: e?.value == undefined ? "" : e?.value,
        },
      });
    }
    if (property === "Guruh turlari") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: { page: 1, group_type: e?.value == undefined ? "" : e?.value },
      });
    }
    if (property === "Dars kunlari") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: {
          page: 1,
          recurring_days: e?.value == undefined ? "" : e?.value,
        },
      });
    }
    if (property === "Binolar") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: {
          page: 1,
          branch: e?.value == undefined ? "" : e?.value,
        },
      });
    }
    if (property === "Xodimlar") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: {
          page: 1,
          teacher: e?.value == undefined ? "" : e?.value,
        },
      });
    }
    if (property === "Oylar") {
      dispatchMainGroups({
        type: MainGroupsActions.ADD_QUERY_PARAM,
        payload: {
          page: 1,
          month: e?.value == undefined ? "" : e?.value,
        },
      });
    }
  });

  return (
    <Select
      classNamePrefix="select"
      placeholder={property}
      styles={customStyles}
      options={param}
      isClearable
      value={value || null}
      onChange={handleSelectChange}
    />
  );
}
